// FlixPlayerActionButton.js
import { connect } from 'react-redux';
import withRouter from '../component/WithRouter.jsx';

import FlixPlayerActionButton from '../component/FlixPlayerActionButton.jsx';

import { replace } from '../action/navigationAction.js';
import login from '../action/login.js';
import sendUnlockMessage from '../action/sendUnlockMessage.js';
import openQuickpayModal from '../action/openQuickpayModal.js';

import getMessageData from '../selector/getMessageData.js';
import getMeBalance from '../selector/getMeBalance.js';
import getMeData from '../selector/getMeData.js';
import getMessageUnlockPrice from '../selector/getMessageUnlockPrice.js';
import getUnlockButtonStatus from '../selector/getUnlockButtonStatus.js';

const mapStateToProps = (state, { messageId }) => {
  const unlockPrice = getMessageUnlockPrice(state, messageId);
  const unlockButtonStatus = getUnlockButtonStatus(state, messageId);
  const balance = getMeBalance(state);
  const isBalanceInsufficient = balance < unlockPrice;

  return {
    isAuthed: !!getMeData(state, 'id'),
    isBalanceInsufficient,
    unlockButtonStatus,
    unlockPrice,
    canViewMedia: getMessageData(state, messageId, 'canViewMedia'),
    badges: getMessageData(state, messageId, 'badges'),
    hasPurchased: getMeData(state, 'lastPurchased'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    login: () => dispatch(login({ isRequireDiamond: true })),
    sendUnlockMessage: data => dispatch(sendUnlockMessage(data)),
    replace: data => dispatch(replace(data)),
    openQuickpayModal: data => dispatch(openQuickpayModal(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FlixPlayerActionButton)
);
